<template>
  <v-dialog :value="dialog" width="1150px" class="d-flex" scrollable persistent>
    <v-card class="dialog-content px-4 py-2">
      <v-card-title class="title mb-1 pa-4">Qual modalidade de sorteio você deseja criar?</v-card-title>
      <v-card-text class="d-flex justify-end align-self-end">
        <v-row>
          <v-card-text class="pt-0">
            <v-row justify="center">
              <v-col v-for="(type, index) in raffleTypes" :key="`${index}-${type.text}`" :cols="raffleCardCols">
                <raffle-type-card
                  :text="type.text"
                  :description="type.description"
                  :image-url="type.imageUrl"
                  :raffle-type="type.raffleType"
                  :selected.sync="selectedType"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-row>
      </v-card-text>
      <p v-if="error" class="ma-0 pl-3 error-message">Selecione uma modalidade</p>

      <mf-action-buttons
        class="pb-4 pr-4"
        :primary-button="{
          text: 'Confirmar',
          action: validateIfHasTypeSelected,
          isVisible: true,
          isDisabled: !selectedType,
        }"
        :extra-button="{
          text: 'Cancelar',
          action: closeDialog,
          isVisible: true,
        }"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import RaffleTypeCard from './RaffleTypeCard.vue'

export default {
  name: 'RaffleTypeDialog',
  components: {
    RaffleTypeCard,
  },
  data: () => ({
    dialog: true,
    error: false,
    selectedType: '',
  }),
  computed: {
    link() {
      return `/mobile/sorteios/novo?raffle-type=${this.selectedType}`
    },
    modules() {
      return this.$getAllowedModules()
    },
    raffleTypes() {
      const raffleTypes = [
        {
          text: 'Por valor de compra',
          description:
            '<p class="descricao-text">Os números da sorte são gerados pelo valor do cupom fiscal. <span class="descricao-emphasis">Ex.: É gerado um número a cada R$ 100,00 em compra.</span></p>',
          raffleType: 'valor-total-cupom',
          imageUrl: './static/img/valor-total-cupom.svg',
        },
        {
          text: 'Por quantidade de produtos',
          description:
            '<p class="descricao-text">Os números da sorte são gerados pela quantidade de uma seleção de produtos. <span class="descricao-emphasis">Ex.: A cada 10 unidades de um produto x.</span></p>',
          raffleType: 'quantidade-items',
          imageUrl: './static/img/quantidade-items.svg',
        },
        {
          text: 'Por valor de compra de uma seleção de produtos',
          description:
            '<p class="descricao-text">Os números da sorte são gerados pelo valor de uma seleção de produtos. <span class="descricao-emphasis">Ex.: A cada R$10,00 em compras de um produto x.</span></p>',
          raffleType: 'valor-items-selecionados',
          imageUrl: './static/img/valor-items-selecionados.svg',
        },
        {
          text: 'Por valor de compra contendo um produto participante',
          description: '<p class="descricao-text">Compras acima do valor especificado que contém um dos produtos participantes recebem um número da sorte.</p>',
          raffleType: 'valor-compra-item-selecionado',
          imageUrl: './static/img/valor-compra-item-selecionado.svg',
        },
        {
          text: 'Por valor de compra com produtos aceleradores',
          description:
            '<p class="descricao-text">Os números da sorte são gerados pelo valor do cupom, caso o consumidor leve um produto participante ele ganha números da sorte extras.</p>',
          raffleType: 'valor-compra-produtos-aceleradores',
          imageUrl: './static/img/valor-compra-produtos-aceleradores.svg',
        },
        {
          text: 'Por valor de compra com grupos de produtos aceleradores',
          description:
            '<p class="descricao-text">Os números da sorte são gerados pelo valor do cupom, caso o consumidor leve produtos dos grupos configurados ele ganha números da sorte extras.</p>',
          raffleType: 'valor-compra-grupos-de-produtos-aceleradores',
          imageUrl: './static/img/valor-compra-grupos-de-produtos-aceleradores.svg',
        },
      ]
      return raffleTypes
    },
    raffleCardCols() {
      return this.raffleTypes.length === 4 ? '6' : '4'
    },
  },
  watch: {
    selectedType() {
      this.error = false
    },
  },
  methods: {
    closeDialog() {
      this.error = false
      this.$emit('input', false)
    },
    validateIfHasTypeSelected() {
      if (this.selectedType) {
        this.closeDialog()
        this.$router.push({ path: this.link })
      } else this.error = true
    },
  },
}
</script>

<style lang="scss">
.dialog-content {
  .block-title {
    opacity: 0.8;
    font-size: 18px;
    font-weight: bold;
    color: $preto;
  }

  .error-message {
    color: $vermelho-0;
  }
}
</style>
